import styles from "./AscTag.module.scss";
import CoinImage from "../../assets/images/coins-image.png";
import { If } from "react-conditional-components-renderer";
import classNames from "classnames";
import { CheckMarkIcon, CloseIcon } from "../AscIcons";
import { AscTagProps } from "./AscTag.types";
import AscImage from "../AscImage/AscImage";

export default function AscTag({
  label,
  type = "default",
  className,
  id,
  onClose,
  size = "medium",
  color, 
  labelClassName
}: AscTagProps) {

  function handleClose() {
    onClose?.(id);
  }
  function getStyles(color?: string): React.CSSProperties {
    return { "--customColor": color || "var(--brandRed)" } as React.CSSProperties;
  }
  return (
    <div
      className={classNames(styles.ground, className, {
        [styles.closablePrimary]: type === "closable-primary",
        [styles.closableSecondary]: type === "closable-secondary",

        [styles.coin]: type === "coin",

        [styles.gold]: type === "gold",
        [styles.silver]: type === "silver",
        [styles.bronze]: type === "bronze",

        [styles.default]: type === "default",
        [styles.blue]: type === "blue",
        [styles.pink]: type === "pink",
        [styles.green]: type === "green",
        [styles.orange]: type === "orange",
        [styles.yellow]: type === "yellow",
        [styles.purple]: type === "purple",
        [styles.lilac]: type === "lilac",
        [styles.red]: type === "red",

        [styles.correct]: type === "correct",
        [styles.incorrect]: type === "incorrect",

        [styles.challenge]: type === "challenge",
        [styles.event]: type === "event",
        [styles.bullpen]: type === "bullpen",
        [styles.badge]: type === "badge",
        [styles.tag]: type === "tag",
        [styles.points]: type === "points",
        [styles.pointsFirstPlace]: type === "points-first-place",
        [styles.pointsSecondPlace]: type === "points-second-place",
        [styles.pointsThirdPlace]: type === "points-third-place",

        [styles.planeBlue]: type === "plane-blue",

        [styles.cardPurple]: type === "card-purple",
        [styles.cardLightGreen]: type === "card-light-green",
        [styles.cardBrandRed]: type === "card-brand-red",
        [styles.cardBrandOrange]: type === "card-brand-orange",
        [styles.cardLightGreenInverted]: type === "card-light-green-inverted",
        [styles.cardBrandRedInverted]: type === "card-brand-red-inverted",

        [styles.competitionFirst]: type === "competition-first",
        [styles.competitionSecond]: type === "competition-second",
        [styles.competitionThird]: type === "competition-third",
        [styles.competitionOther]: type === "competition-other",

        [styles.custom]: type === "custom",

        [styles.small]: size === "small",
        [styles.medium]: size === "medium",
      })}

      style={getStyles(color)}
    >
      <If test={type === "coin"}>
        <AscImage
          className={styles.image}
          alt="Coins"
          src={CoinImage}
          width={24}
          height={24}
        />
      </If>

      <If test={type === "correct" || type === "incorrect"}>
        <CloseIcon className={styles.incorrectIcon} />
        <CheckMarkIcon className={styles.correctIcon} />
      </If>

      <span className={classNames(styles.label, labelClassName)}>{label}</span>

      <If test={type === "closable-primary" || type === "closable-secondary"}>
        <CloseIcon className={styles.closeIcon} onClick={handleClose} />
      </If>
    </div>
  );
}
